// @flow
import * as React from 'react';

import { PrimaryText } from '../../../Typography.jsx';
import SimpleTable from '../../../SimpleTable.jsx';
import examItems from '../physicalExaminationItems';

import styles from '../../../../styles/patientPages/wellChildCheck/PhysicalExam.scss';

type Props = {
  physicalExamination: Object,
}

class ViewPhysicalExamination extends React.Component<Props> {
  render() {
    const physicalExamination = examItems.map(
      (itemName, index) => ({
        itemName,
        ...this.props.physicalExamination[index],
      }),
    );

    const columns = [
      {
        Header: 'Item',
        id: 'itemName',
        accessor: 'itemName',
        width: 200,
      },
      {
        Header: 'Result',
        id: 'result',
        width: 150,
        Cell: item => (item.original.normal === false
          ? 'Abnormal' : item.original.normal ? 'Normal' : '--'),
      },
      {
        Header: 'Abnormalities/Comments',
        id: 'comments',
        accessor: 'comments',
      },
    ];

    return (
      <div>
        <PrimaryText>Physical Examination</PrimaryText>
        <div className={styles.table}>
          <SimpleTable
            data={physicalExamination}
            columns={columns}
            style={{}} // override max height on default Table
          />
        </div>
      </div>
    );
  }
}

export default ViewPhysicalExamination;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/view/ViewPhysicalExamination.jsx